import './style.css';

BX.ready(function () {
	if (typeof window.JCTitleSearchParams !== undefined) {
		const searchParams = window.JCTitleSearchParams;
		const searchInput = document.getElementById(searchParams.INPUT_ID);
		new JCTitleSearch({
			'AJAX_PAGE': searchParams.AJAX_PAGE,
			'CONTAINER_ID': searchParams.CONTAINER_ID,
			'INPUT_ID': searchParams.INPUT_ID,
			'MIN_QUERY_LEN': searchParams.MIN_QUERY_LEN
		});
		document.addEventListener("keydown", function (event) {
			if (event.ctrlKey && event.shiftKey && event.key === "F") {
				if (searchInput !== undefined && searchInput !== document.activeElement) {
					searchInput?.focus();
					searchInput?.scrollIntoView();
				}
			} else if (event.keyCode == 27) {
				if (searchInput !== undefined && searchInput === document.activeElement) {
					searchInput?.blur();
					searchInput.value = "";
				}
			}
		});
		searchInput?.addEventListener('focus', function () {
			setTimeout(() => {
				searchInput.select();
			}, 0);
		});
		searchInput?.addEventListener('touchstart', function () {
            if(searchInput !== document.activeElement)
			setTimeout(() => {
				searchInput.focus();
				searchInput.select();
			}, 0);
		});
	}
});
